module.exports = __webpack_public_path__ + "media/images/favicons/apple-icon-152x152-6666011b3b69cc9a1012cf794ced9669.png";